if (!customElements.get('measurement-area')) {

    class measurementArea extends HTMLElement {

        constructor() {
            super();

            this.elements = {
                form: this.querySelector('form'),
                dropdowns: this.querySelectorAll('select'),
                customerIdInput: this.querySelector('input[name="customer-id"]'),
                customerEmailInput: this.querySelector('input[name="customer-email"]'),
                shopUrl: this.dataset.shopurl,
                success: this.querySelector('[data-success]'),
                error: this.querySelector('[data-error]'),
                cancel: this.querySelector(".cancel-measurement")
            }

            this.elements.form.addEventListener('submit', this.formSubmission.bind(this));
            this.elements.cancel.addEventListener('click', this.formCancel.bind(this));
        }

        async formSubmission(event) {

            event.preventDefault();
          
            let lingerieCupSize, lingerieBandSize, lingerieSize, sleepwearTop, sleepwearBottom, swimwearTop, swimwearBottom, shapewearTop, shapewearBottom;
            let customerId = this.elements.customerIdInput.value;
            let customerEmail = this.elements.customerEmailInput.value;
            const isDesktop = window.matchMedia('(min-width: 768px)').matches;
            const submitButton = this.elements.form.querySelector('button[type="submit"]');
            const btnLoadingText = submitButton.dataset.btnLoading
            const btnText = submitButton.dataset.btnContent

            submitButton.disabled = true;
            submitButton.textContent = btnLoadingText

            if (!this.elements.dropdowns && !customerId && !customerEmail) {
              console.error("Form elements are missing.");
              return;
            }
          
            this.elements.dropdowns.forEach(dropdown => {
              switch (dropdown.name) {
                case 'measurement-cup-size':
                  lingerieCupSize = dropdown.value;
                  break;
                case 'measurement-band-size':
                  lingerieBandSize = dropdown.value;
                  break;
                case 'measurement-size':
                  lingerieSize = dropdown.value;
                  break;
                case 'measurement-sleepwear-top':
                  sleepwearTop = dropdown.value;
                  break;
                case 'measurement-sleepwear-bottom':
                  sleepwearBottom = dropdown.value;
                  break;
                case 'measurement-swimwear-top':
                  swimwearTop = dropdown.value;
                  break;
                case 'measurement-swimwear-bottom':
                  swimwearBottom = dropdown.value;
                  break;
                case 'measurement-shapewear-top':
                  shapewearTop = dropdown.value;
                  break;
                case 'measurement-shapewear-bottom':
                  shapewearBottom = dropdown.value;
                  break;
              }
            });
                    
            if (!this.elements.shopUrl) {
              console.error("Shop URL is not defined.");
              return;
            }
          
            try {
              const response = await fetch(this.elements.shopUrl + "/apps/spapp/updateCustomerMeasurements", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  customerId,
                  customerEmail,
                  lingerieCupSize,
                  lingerieBandSize,
                  lingerieSize,
                  sleepwearTop,
                  sleepwearBottom,
                  swimwearTop,
                  swimwearBottom,
                  shapewearTop,
                  shapewearBottom
                }),
              });
          
              if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
              }
          
              const data = await response.json();
              submitButton.disabled = false;
              submitButton.textContent = btnText;
              isDesktop ? document.body.scrollIntoView({ block: "start", behavior: "smooth" }) : this.scrollIntoView({ block: "center", inline: "nearest",  behavior: "smooth" });
                                      
              this.elements.success.style.display = 'flex';
              setTimeout(() => {
                this.elements.success.style.display = 'none';
              }, 1800);
          
            } catch (err) {
              console.error("Fetch error:", err);

              isDesktop ? document.body.scrollIntoView({ block: "start", behavior: "smooth" }) : this.scrollIntoView({ block: "center", inline: "nearest",  behavior: "smooth" });

              this.elements.error.style.display = 'flex';
              setTimeout(() => {
                this.elements.error.style.display = 'none';
            }, 2200);

            submitButton.disabled = false;
            submitButton.textContent = btnText;

            }
          }

          formCancel() {          
            this.elements.dropdowns.forEach(dropdown => {  
              const selectedOption = dropdown.querySelector("option[selected]");  
              if (selectedOption) { 
                  dropdown.value = selectedOption.value; 
              }
          });          
          }
    }

    customElements.define('measurement-area', measurementArea);
}